import axiosHandler from '../axiosInterceptors';
import { FETCH_FIRMWARE_DATA, CREATE_FIRMWARE_DATA, UPDATE_FIRMWARE_DATA, DELETE_FIRMWARE_DATA, UPLOAD_FIRMWARE_DATA, UPDATE_FIRMWARE_DCL, DELETE_FIRMWARE_DCL, PUBLISH_FIRMWARE_DCL, REMOVE_UPLOADED_FIRMWARE_DATA, DOWNLOAD_FIRMWARE, CREATE_USERMANUAL_DATA, CREATE_PAI_DATA, UPLOAD_PAI_DATA, DELETE_PAI_DATA, DELETE_USERMANUAL_DATA, UPLOAD_USERMANUAL_DATA, FETCH_PAI_USERMANUAL_DATA, DOWNLOAD_DOC} from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchFirmwareData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_FIRMWARE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchPAI_UsermanualData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_PAI_USERMANUAL_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function uploadPAI(fileData) {
    try{
        const resp = await axiosHandler.post(UPLOAD_PAI_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
        return resp;
    }
    catch(error){
        throw new Error('Error uploading document' + error.message)
    }
}

export async function uploadUserManual(fileData) {
    try{
        const resp = await axiosHandler.post(UPLOAD_USERMANUAL_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
        return resp;
    }
    catch(error){
        throw new Error('Error uploading document' + error.message)
    }
}

export async function createPai(data) {
    try{
        const resp = await axiosHandler.post(CREATE_PAI_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createUserManual(data) {
    try{
        const resp = await axiosHandler.post(CREATE_USERMANUAL_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createFirmwareData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_FIRMWARE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateFirmwareData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_FIRMWARE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteFirmwareData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_FIRMWARE_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deletePaiData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_PAI_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteUserManualData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_USERMANUAL_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function uploadFirmware(fileData){
    try{
        const resp = await axiosHandler.post(UPLOAD_FIRMWARE_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
        return resp;
    }
    catch(error){
        throw new Error('Error uploading document' + error.message)
    }
}

export async function removeUploadedDoc(fileData){
    try{
        const resp = await axiosHandler.post(REMOVE_UPLOADED_FIRMWARE_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
        return resp;
    }
    catch(error){
        throw new Error('Error uploading document' + error.message)
    }
}

export async function publishFirmwareDCL(data, source) {
    try{
        const resp = await axiosHandler.post(PUBLISH_FIRMWARE_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateFirmwareDCL(data, source) {
    try{
        const resp = await axiosHandler.patch(UPDATE_FIRMWARE_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteFirmwareDCL(data, source) {
    try{
        const resp = await axiosHandler.post(DELETE_FIRMWARE_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function downloadDoc(data) {
    try{
        const resp = await axiosHandler.post(DOWNLOAD_DOC, data, {responseType: 'blob'});
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function downloadFirmwareDoc(data) {
    try{
        const resp = await axiosHandler.post(DOWNLOAD_FIRMWARE, data, {responseType: 'blob'});
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}
